'use client'

import * as React from 'react'
import { i18Config } from '@/config/playerLang'

export default function OverlayUnmuteButton () {
  // click event for the unmute button in the htl5eventadapter.js
  const [browserLang, setLanguage] = React.useState('en')

  React.useEffect(() => {
    // get the navigator language
    const lang = navigator.language || navigator.userLanguage

    // check the language is supported or not
    if (lang) {
      const browserLangCode = lang.split('-')[0]
      if (i18Config[browserLangCode]) {
        setLanguage(i18Config[browserLangCode])
      } else {
        setLanguage(i18Config.en)
      }
    }
  }, [])

  return (
    <div className='overlay-unmute-button overflow-visible z-100' style={{ display: 'block' }} id='unmute-button-outer'>
      <button
        className='flex items-center lg:gap-2 gap-1  md:text-sm text-xs leading-6 bg-gray-950/80 px-2 lg:py-2 py-1 rounded-lg lg:text-base font-medium ring-[0.5px] ring-opacity-40 ring-gray-500 hover:bg-gray-950 hover:text-white hover:opacity-100 hover:transform hover:ease-in-out hover:delay-50'
        id='unmute-button'
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          fill='#fafafa'
          stroke='currentColor'
          viewBox='0 0 256 256'
          className='w-3 h-3 sm:h-5 sm:w-5'
        >
          <path d='M213.92,210.62a8,8,0,1,1-11.84,10.76L160,175.09v48.6a8.29,8.29,0,0,1-3.91,7.18,8,8,0,0,1-9-.56l-65.55-51A4,4,0,0,1,80,176.18V87.09L42.08,45.38A8,8,0,1,1,53.92,34.62Zm-27.21-55.46a8,8,0,0,0,11.29-.7,40,40,0,0,0,0-52.88,8,8,0,1,0-12,10.57,24,24,0,0,1,0,31.72A8,8,0,0,0,186.71,155.16Zm40.92-80.49a8,8,0,1,0-11.92,10.66,64,64,0,0,1,0,85.34,8,8,0,1,0,11.92,10.66,80,80,0,0,0,0-106.66ZM153,119.87a4,4,0,0,0,7-2.7V32.25a8.27,8.27,0,0,0-2.88-6.4,8,8,0,0,0-10-.16L103.83,59.33a4,4,0,0,0-.5,5.85ZM60,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H60a4,4,0,0,0,4-4V84A4,4,0,0,0,60,80Z' />
        </svg>
        <span className='drop-shadow-lg shadow-slate-50 text-white'>{browserLang.enableSound}</span>
      </button>
    </div>
  )
};
